import { render, staticRenderFns } from "./Bigfive.vue?vue&type=template&id=aff4f9c2&"
import script from "./Bigfive.vue?vue&type=script&lang=js&"
export * from "./Bigfive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports